import {
  CrSubItemsSelect,
  Props as CrSubItemsSelectProps,
} from '@/components/CrSubItemsSelect';
import { PaymentRequestForm } from '@/features/InvoiceReport/Edit/type';
import { memo, useCallback, useMemo } from 'react';
import {
  FieldPath,
  Path,
  PathValue,
  useFormContext,
  useWatch,
} from 'react-hook-form';
import { CellProps } from './type';

type Props<TFieldValues extends PaymentRequestForm> =
  CrSubItemsSelectProps<TFieldValues> &
    CellProps & {
      crItemName: FieldPath<TFieldValues>;
    };

const InnerCrSubItemsSelectCell = <TFieldValues extends PaymentRequestForm>({
  index,
  ...props
}: Props<TFieldValues>) => {
  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
  const crItemId = useWatch<TFieldValues>({
    name: props.crItemName,
    control: props.control,
  }) as PathValue<TFieldValues, Path<TFieldValues>> | undefined;
  const cacheKey = useMemo(
    () => ['row', 'cr_sub_item', crItemId, index],
    [index, crItemId]
  );
  const { setValue } = useFormContext<PaymentRequestForm>();
  const setLabelField = useCallback(
    (labelFieldValue: string) => {
      setValue(`invoiceTransactions.${index}.crSubItemName`, labelFieldValue);
    },
    [setValue, index]
  );

  return (
    <CrSubItemsSelect<TFieldValues>
      per={500}
      cacheQueryKey={cacheKey}
      crItemId={crItemId}
      {...props}
      setLabelField={setLabelField}
    />
  );
};
InnerCrSubItemsSelectCell.displayName = 'InnerCrSubItemsSelectCell';

// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
export const CrSubItemsSelectCell = memo(
  InnerCrSubItemsSelectCell
) as typeof InnerCrSubItemsSelectCell;
CrSubItemsSelectCell.displayName = 'CrSubItemsSelectCell';
